export default __webpack_public_path__ + "static/WhatStats_Logo_S-b48905763ec809159b574c2f9f5967d7.png";